import {
    TweenMax,
    TimelineLite
} from 'gsap'

import 'slick-carousel'
import 'jquery-lazy'

var slideTxtAnimation = new TimelineLite();
slideTxtAnimation.paused(true);

function animateSliderTxt(elements) {
    slideTxtAnimation.staggerFromTo(elements, 0.6, {
        // y: -200,
        opacity: 0
    }, {
        // y: 0,
        opacity: 1
    }, 0.250);
    slideTxtAnimation.play();
}

$('.home-slider').on('init', function () {

    // PLAY VIDEO
    var $video = $("[data-slick-index='0']").find("video");
    if ($video.length) {
        $video.get(0).play();
    }

    // TXT ANIMATION
    $('.lazy').Lazy({
        afterLoad: function (element) {
            var curentSlide = element.closest('.slick-current');
            var currentTxt = curentSlide.find('.slide-txt *');
            animateSliderTxt(currentTxt);
        }
    });

}).slick({
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1500,
    arrows: false,
    dots: true,
    rows: 0,
    infinite: false,
    fade: true
}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

    // TXT HIDE
    var nextTxt = $("[data-slick-index='" + nextSlide + "']").find(".slide-txt *");
    nextTxt.css({
        opacity: 0
    });

    // PLAY VIDEO
    var $video = $("[data-slick-index='" + nextSlide + "']").find("video");
    if ($video.length) {
        $video.get(0).play();
    }

}).on('afterChange', function (event, slick, currentSlide) {
    currentSlide = parseInt(currentSlide);
    var previousSlide = currentSlide - 1;

    // TXT ANIMATION
    var currentTxt = $("[data-slick-index='" + currentSlide + "']").find(".slide-txt *");
    animateSliderTxt(currentTxt);
});